export default __webpack_public_path__ + "static/media/Mask Group 2.c5b67508.png";